import { render } from "./Exchange.vue?vue&type=template&id=ab688126&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"

import "./Exchange.vue?vue&type=style&index=0&id=ab688126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab688126"]])

export default __exports__